export default function ReportHeader(props)
{
    function formatDate(dt) {
        let date = new Date(dt);
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();
        
        return `${month}/${day}/${year}`;
      }

    return(<>
            <tr className="reportHeaderFirstRow">
                <th>
                    <h2>Peer Group {props.peerName} {props.financials[0].isYTD ? "YTD" : "Fiscal"}</h2>
                </th>
                {props.financials.map((f)=>{
                    return (<th colSpan="2" key={f.fiscalInputId}>
                        {f.companyName}<br/>
                        {f.division}<br/>
                        {f.isYTD ? formatDate(f.fiscalStart): new Date(f.fiscalEnd).getFullYear()}
                        {f.isYTD ? " YTD" : " Full Fiscal"}
                    </th>);
                })}
            </tr>
            <tr className="reportHeaderRow">
            <th className="reportMetric">Metric Name</th>
            {props.financials.map((f,index)=>{
                    return (
                        <>         
                        <th>Value</th>
                        <th>%</th>
                        </>
                    );
                })}
            </tr>
    </>);
}